
import { useState } from "react";
import AcceleratorApplicationModal from "@/components/pricing/AcceleratorApplicationModal";
import PricingNavigation from "@/components/pricing/PricingNavigation";
import PricingHero from "@/components/pricing/PricingHero";
import ApplicationCards from "@/components/pricing/ApplicationCards";
import RecognizedAccelerators from "@/components/pricing/RecognizedAccelerators";
import FeaturesSection from "@/components/pricing/FeaturesSection";
import TestimonialsSection from "@/components/pricing/TestimonialsSection";
import FAQSection from "@/components/pricing/FAQSection";
import CTASection from "@/components/pricing/CTASection";
import PricingFooter from "@/components/pricing/PricingFooter";

const RequestAccessPage = () => {
  const [showTechstarsModal, setShowTechstarsModal] = useState(false);
  const [showOtherModal, setShowOtherModal] = useState(false);

  const handleTechstarsClick = () => setShowTechstarsModal(true);
  const handleOtherClick = () => setShowOtherModal(true);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <PricingNavigation />
      <PricingHero 
        onTechstarsClick={handleTechstarsClick}
        onOtherClick={handleOtherClick}
      />
      <ApplicationCards 
        onTechstarsClick={handleTechstarsClick}
        onOtherClick={handleOtherClick}
      />
      <RecognizedAccelerators />
      <FeaturesSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection 
        onTechstarsClick={handleTechstarsClick}
        onOtherClick={handleOtherClick}
      />
      <PricingFooter />

      {/* Modals */}
      <AcceleratorApplicationModal
        isOpen={showTechstarsModal}
        onClose={() => setShowTechstarsModal(false)}
        acceleratorType="techstars"
      />
      
      <AcceleratorApplicationModal
        isOpen={showOtherModal}
        onClose={() => setShowOtherModal(false)}
        acceleratorType="other"
      />
    </div>
  );
};

export default RequestAccessPage;
